// extracted by mini-css-extract-plugin
export default {"link":"ErrorBoundaryFallback__link--Voqz1","loading-shimmer":"ErrorBoundaryFallback__loading-shimmer--aOUEe","loadingShimmer":"ErrorBoundaryFallback__loading-shimmer--aOUEe"};